import React from "react";
import { useI18n } from "../i18n/I18nContext";

const LANGS = [
  { code: "en", label: "EN", title: "English" },
  { code: "fr", label: "FR", title: "Français" },
  { code: "ht", label: "Kreyòl", title: "Kreyòl ayisyen" },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div data-testid="language-switcher" className="flex items-center gap-1 border border-[#222] rounded-sm p-0.5">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          title={l.title}
          className={`px-2.5 py-1 text-xs font-condensed tracking-widest transition-colors ${
            lang === l.code ? "bg-[#d4af37] text-black" : "text-neutral-400 hover:text-[#d4af37]"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
